export default {"src":"/_next/static/media/pencil-outlined.c2154e4b.svg","height":24,"width":24};